import {translate} from './preferences';

const messages = {
    idle: ['newsletterSubscribe', 'newsletterHint'],
    sending: ['newsletterSending', 'newsletterSendingHint'],
    sent: ['newsletterSent', 'newsletterConfirmation'],
    invalid: ['newsletterSubscribe', 'newsletterInvalid'],
    error: ['retry', 'newsletterError']
};

export default function newsletter() {
    const form = document.querySelector('[data-newsletter-form]');
    if (!form) return;
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    let state = 'idle';

    function render(next = state) {
        state = next;
        form.dataset.state = state;
        form.setAttribute('aria-busy', String(state === 'sending'));
        input.readOnly = state === 'sending';
        input.setAttribute('aria-invalid', String(state === 'invalid'));
        button.disabled = state === 'sending' || state === 'sent';
        button.textContent = translate(messages[state][0]);
        status.textContent = translate(messages[state][1]);
    }

    form.noValidate = true;
    input.disabled = false;
    input.addEventListener('input', () => {
        if (state !== 'sending') render('idle');
    });
    window.addEventListener('tiwb:language', () => render());
    form.addEventListener('submit', async event => {
        event.preventDefault();
        if (state === 'sending' || state === 'sent') return;
        input.value = input.value.trim();
        if (!input.checkValidity()) {
            render('invalid');
            input.focus();
            return;
        }
        const email = input.value;
        render('sending');
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        try {
            // Ghost's public Members API owns confirmation and default newsletters.
            // Handle the request here so network failures and timeouts remain retryable.
            const endpoint = new URL(form.action);
            const options = {credentials: 'same-origin', signal: controller.signal};
            const tokenResponse = await fetch(new URL('../integrity-token/', endpoint), {...options, cache: 'no-store'});
            if (!tokenResponse.ok) throw new Error('Unable to start subscription');
            const integrityToken = await tokenResponse.text();
            const response = await fetch(endpoint, {
                ...options,
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, emailType: 'subscribe', autoRedirect: true, integrityToken})
            });
            if (!response.ok) throw new Error('Unable to send confirmation');
            render('sent');
        } catch (_) {
            render('error');
        } finally {
            window.clearTimeout(timeout);
        }
    });
    render();
}
